/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready () {
            console.log(
                'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB',
            )
        },
        registered (registration) {
            console.log('Service worker has been registered.')

            // @see https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip#comment-1mje4
            setInterval(() => {
                registration.update()
            }, 5000) // Every 5 seconds
        },
        cached () {
            console.log('Content has been cached for offline use.')
        },
        updatefound (registration) {
            console.log('New content is downloading.')

            // @see https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
            document.dispatchEvent(new CustomEvent('serviceWorkerUpdated', { detail: registration }))
        },
        updated (registration) {
            console.log('New content is available; please refresh.')

            // @see https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
            document.dispatchEvent(new CustomEvent('serviceWorkerUpdated', { detail: registration }))
        },
        offline () {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error (error) {
            console.error('Error during service worker registration:', error)
        },
    })
}
